export default "__VITE_ASSET__Dzc046Uo__"